<script setup lang="ts">
import { useElementId } from '../../common/composables/useElementId';
import { InputText, Message } from 'primevue';

const props = defineProps<{
  title: string,
  changed: boolean,
  error?: string
  disabled?: boolean;
  autofocus?: boolean;
}>();
const modelValue = defineModel<string|undefined>({ required: true });
const elementId = useElementId();

</script>

<template>
  <div class="field" :class="{ changed: props.changed }">
    <label :for="elementId">{{ props.title }}</label>
    <InputText :invalid="props.error !== undefined" :autofocus="props.autofocus" autocomplete="off" v-model:modelValue="modelValue" :id="elementId" :disabled="disabled"></InputText>
    <Message v-if="props.error" severity="error" variant="simple">{{ props.error }}</Message>
  </div>
</template>
